<template>
  <div class="user-list">
    <div class="search-bar f-between">
      <div class="m-left">
        <el-input v-model="searchParam.keyword_search" placeholder="输入名称" clearable @clear="getList"></el-input>
        <el-date-picker
          v-model="searchParam.date"
          type="daterange"
          range-separator="至"
          start-placeholder="开始日期"
          value-format="yyyy-MM-dd"
          end-placeholder="结束日期"
          @change="getList"
        >
        </el-date-picker>
        <el-button type="primary" @click="getList('clear')">查询</el-button>
      </div>
      <div class="m-right">
        <el-button type="primary" @click="handleDownTemp">模板下载</el-button>
        <el-button type="primary" class="m-btn">
          <span>导入</span>
          <div class="m-cover">
            <input type="file" @change="handleImport" />
          </div>
        </el-button>
        <el-button type="primary" @click="addbox = true">新增科目</el-button>
      </div>
    </div>

    <div class="table">
      <el-table v-loading="loading" :data="tableData" border style="width: 100%">
        <el-table-column prop="name" label="科目名称" align="center"> </el-table-column>
        <el-table-column prop="num" label="题目数量" align="center"> </el-table-column>
        <el-table-column prop="create_time" label="创建时间" align="center"> </el-table-column>
        <el-table-column label="操作" fixed="right" width="140">
          <template slot-scope="scope">
            <el-button class="mid-blue" @click="editRow(scope.row)">编辑</el-button>
            <el-button class="mid-red" @click="delItem(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination">
        <el-pagination
          :current-page="searchParam.page_index"
          :page-size="searchParam.page_size"
          :total="total"
          :page-sizes="[10, 20, 60, 100]"
          layout="total, sizes, prev, pager, next, jumper"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
        >
        </el-pagination>
      </div>
    </div>

    <el-dialog :title="form.uuid ? '编辑科目' : '添加科目'" :visible.sync="addbox" center :before-close="closeForm">
      <el-form ref="ruleForm" :model="form" label-position="left" :rules="rules" label-width="100px" class="add-form">
        <el-form-item label="科目名称" prop="name">
          <el-input v-model="form.name"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="closeForm">取 消</el-button>
        <el-button type="primary" @click="subForm">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import imgUpload from "@/components/pub/imgUploadNormal.vue";
import { subjectTipList, addSubjectTip, editSubjectTip, delSubjectTip, importSubjectTip } from "@/api/edu.js";
import { mixin } from "@/mixins/pagination.js";

export default {
  components: {
    imgUpload,
  },
  mixins: [mixin],
  data() {
    return {
      addbox: false,
      form: { name: "", uuid: "" },
      ruleForm: {},
      rules: {
        name: [
          {
            required: true,
            message: "请输入科目名称",
            trigger: "blur",
          },
        ],
      },
      loading: false,
      searchParam: {
        keyword_search: "",
        date: [],
        page_index: 1,
        page_size: 10,
      },
      tableData: [],
      total: 0,
    };
  },
  mounted() {
    this.getList();
  },
  methods: {
    closeForm() {
      this.form = { name: "", uuid: "" };
      this.addbox = false;
    },
    editRow(row) {
      this.form = { name: row.name, uuid: row.uuid };
      this.addbox = true;
    },
    delItem(row) {
      this.$confirm("确定要删除吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          delSubjectTip(row.uuid).then((res) => {
            if (res) {
              this.$message.success("成功");
              this.getList();
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    subForm() {
      this.$refs["ruleForm"].validate((valid) => {
        if (valid) {
          if (this.form.uuid) {
            editSubjectTip(this.form, this.form.uuid).then((res) => {
              if (res == true) {
                this.$message.success("成功");
                this.getList();
                this.closeForm();
              }
            });
          } else {
            addSubjectTip(this.form).then((res) => {
              console.log(res);
              if (res == true) {
                this.$message.success("成功");
                this.getList();
                this.closeForm();
              }
            });
          }
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    async getList() {
      const param = {
        ...this.searchParam,
        start_time: (this.searchParam.date && this.searchParam.date[0]) || undefined,
        end_time: (this.searchParam.date && this.searchParam.date[1]) || undefined,
        date: undefined,
      };
      // return
      this.loading = true;
      const res = await subjectTipList(param);
      this.loading = false;
      if (res.data instanceof Array) {
        this.tableData = res.data;
        this.total = res.total;
      }
    },
    handleDownTemp() {
      window.open(`https://train-service-api.procaregroup.com/excel/tiptpl.xlsx`);
    },
    async handleImport(e) {
      const file = e.target.files[0];
      const formData = new FormData();
      formData.append("file", file);
      const res = await importSubjectTip(formData);
      if (!res.result) return this.$message.error("导入失败");
      this.$message.success(res.result);
      this.getList();
    },
  },
};
</script>

<style scoped="scoped">
.user-list {
  background: white;
  padding: 10px;
  box-sizing: border-box;
}
.add-form {
  max-height: 80vh;
  overflow: auto;
}
.m-btn {
  position: relative;
  .m-cover {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    overflow: hidden;
    opacity: 0;
  }
}
</style>
